var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          staticClass: "navbar",
          class: { "nav-mobile": _vm.$uiHelpers.isMobile }
        },
        [
          _c("b-navbar-brand", { attrs: { href: "/opensaludprime" } }, [
            _c("img", {
              staticClass: "navbar-brand-img-bigger",
              attrs: {
                src: "/static-appopensalud/img/logos/primesalud_blue_02.svg"
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "d-none-xs" },
            [
              _c("lang-selector", { staticClass: "d-inline-block mr-4" }),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  attrs: { blue: "" },
                  on: {
                    click: function($event) {
                      return _vm.$helpers.goToSection("companies-contact-form")
                    }
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("more-info-btn")))]),
                  _vm._v(" "),
                  _c("base-icon", {
                    staticClass: "ml-2",
                    attrs: {
                      src:
                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                      color: "white"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("primesalud-discounts-second-block"),
      _vm._v(" "),
      _c("primesalud-discounts-main-block"),
      _vm._v(" "),
      _c("companies-contact-form", {
        attrs: {
          id: "companies-contact-form",
          forIndividualsOnly: "",
          platform: "Opensaludprime",
          productName: "Opensaludprime"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c29ac8d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c29ac8d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/landing/PrimeSaludDiscounts.vue
// module id = 4091
// module chunks = 42